'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MPPHeaderRoot2 = require('./../components/MPPHeaderRoot');

var _MPPHeaderRoot3 = _interopRequireDefault(_MPPHeaderRoot2);

var _MPPMainMenu = require('./MPPMainMenu');

var _MPPMainMenu2 = _interopRequireDefault(_MPPMainMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MPPHeaderRootCustom = function (_MPPHeaderRoot) {
  _inherits(MPPHeaderRootCustom, _MPPHeaderRoot);

  function MPPHeaderRootCustom() {
    _classCallCheck(this, MPPHeaderRootCustom);

    return _possibleConstructorReturn(this, (MPPHeaderRootCustom.__proto__ || Object.getPrototypeOf(MPPHeaderRootCustom)).apply(this, arguments));
  }

  _createClass(MPPHeaderRootCustom, [{
    key: 'renderMainMenu',
    value: function renderMainMenu() {
      if (this.props.config.useMinimalHeader || !this.props.content.mainMenuContent) {
        return null;
      }
      return _react2.default.createElement(_MPPMainMenu2.default, {
        content: this.props.content,
        activeLinkIndex: this.props.activeLinkIndex,
        closingLinkIndex: this.props.closingLinkIndex,
        handlers: this.props.handlers,
        register: this.props.register
      });
    }
  }]);

  return MPPHeaderRootCustom;
}(_MPPHeaderRoot3.default);

exports.default = MPPHeaderRootCustom;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/v3/MPPHeaderRoot.js
// module id = 1099
// module chunks = 4